<div class="flex w-full flex-col space-y-4">
  <div
    [ngClass]="{ 'cursor-pointer': !disabled() }"
    (click)="toggle()"
    class="group relative my-4 flex min-w-full cursor-pointer flex-row-reverse justify-end first:mt-0 last:mb-0 focus-visible:outline-none">
    <input (change)="toggle()" [id]="'mcb-' + ngControl?.name" [name]="'mcb-' + ngControl?.name" class="hidden" type="checkbox" />
    <label
      [ngClass]="{ 'cursor-pointer': !disabled(), 'text-neutral-60': disabled() }"
      [for]="'mcb-' + value"
      class="peer col-start-2 row-start-1 w-full pl-2 text-left">
      <div class="h-full w-full content-center">
        <ng-content></ng-content>
      </div>
    </label>
    <button
      [disabled]="disabled()"
      [title]="label()"
      [ngClass]="{ 'hover:text-primary-130': !disabled() }"
      aria-checked="false"
      aria-invalid="false"
      class="focus-visible:secondary-5 'after:content-['']' 'focus-visible:before:content-['']' col-start-1 row-start-1 flex text-neutral-60 ring-secondary-20 after:absolute after:left-1 after:top-1 after:-z-10 after:flex after:h-4 after:w-4 after:bg-neutral-0 focus-visible:text-primary-100 focus-visible:outline-none focus-visible:before:absolute focus-visible:before:-left-2 focus-visible:before:-top-2 focus-visible:before:-z-20 focus-visible:before:flex focus-visible:before:h-10 focus-visible:before:w-10 focus-visible:before:rounded-full focus-visible:before:bg-secondary-20 peer-hover:text-primary-130"
      role="checkbox">
      @if (isSelected()) {
        <svg [class]="!disabled() ? 'text-primary' : 'text-neutral-60'" [attr.width]="size()" [attr.height]="size()" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="2" width="20" height="20" rx="4" fill="currentColor"></rect>
          <path d="M17 8L10.125 16L7 12.3636" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      } @else {
        <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2.5" y="2.5" width="19" height="19" rx="3.5" fill="white" stroke="currentColor"></rect>
        </svg>
      }
    </button>
  </div>
</div>

@if (ngControl) {
  <pay-field-multi-validator [ngControl]="[ngControl]" [pendingObs]="pendingSubject.asObservable()" />
}
